import { IApplicationState, IThunkContext, TThunkDispatch } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { actionTypes } from '../../constants/actionTypes';

import {
  IGetArticlesListResponse,
  IGetArticlesListResponse200,
  IGetArticlesListResponse400,
  fetchGetArticlesList,
} from '../../repositories/valuation-b2b/v1/get-articles-list';

const {
  GET_PUBLICATIONS_LIST_REQUEST: REQUEST,
  GET_PUBLICATIONS_LIST_SUCCESS: SUCCESS,
  GET_PUBLICATIONS_LIST_FAILURE: FAILURE,
} = actionTypes;

const requestAction = actionGenerator<typeof REQUEST>(REQUEST);
const successAction = actionGenerator<typeof SUCCESS, IGetArticlesListResponse>(SUCCESS);
const failureAction = actionGenerator<typeof FAILURE>(FAILURE);

export const getPublicationsList = () => (
  dispatch: TThunkDispatch,
  getState: () => IApplicationState,
  context: IThunkContext,
) => {
  const timeout = context.config.get<number>('valuationB2bGetPublicationsTimeout') || 3000;

  dispatch(requestAction());

  return fetchGetArticlesList<IGetArticlesListResponse200, IGetArticlesListResponse400>({
    httpApi: context.httpApi,
    parameters: {},
    config: {
      ecnhancersConfig: { timeout },
    },
  })
    .then(response => {
      if (response.statusCode === 200) {
        dispatch(successAction(response.response));
      } else {
        dispatch(failureAction());
      }
    })
    .catch(error => {
      if (context.logger) {
        context.logger.error(error, { message: 'Api error /v1/get-articles-list/' });
      }

      dispatch(failureAction());
    });
};
